export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-26-C-front-WEB-aee152e9401def920b5519110c51a826.png";